export const GET_FOLLOWUPS = "GET_FOLLOWUPS";
export const ADD_FOLLOWUP = "ADD_FOLLOWUP";
export const EDIT_FOLLOWUP = "EDIT_FOLLOWUP";
export const GET_FOLLOWUP = "GET_FOLLOWUP";
export const RESET_FOLLOWUP = "RESET_FOLLOWUP";
export const ERROR_FOLLOWUP = "ERROR_FOLLOWUP";
export const GET_ALL_FOLLOWUPS = "GET_ALL_FOLLOWUPS";
export const GET_LEAD_FOLLOWUPS = "GET_LEAD_FOLLOWUPS";
